import { createContext, useContext } from 'react';
export var CheckboxGroupContext = /*#__PURE__*/createContext({
  checkbox: {}
});
export var useCheckboxGroupContext = function () {
  return useContext(CheckboxGroupContext);
};